export default {
  sap: {
    metadata: {
      title: 'Inteligência SAP - SIS Innov & Tech',
      desc: 'Soluções SAP para impulsionar os seus negócios! Da consultoria e implantação até atualização e suporte AMS. Saiba mais.',
    },
    hero: {
      title: 'Inteligência SAP',
      desc: 'Conheça os nossos<br /> serviços!',
    },
    apresentation: {
      p1: 'Ter <span class="font-black">uma empresa parceira que te ajuda em todas as etapas do processo</span> para ter um sistema ERP referência no mercado faz toda diferença nos seus resultados.',
      p2: 'Em nossa Unidade de Inteligência SAP, temos especialistas que oferecem uma abordagem completa e personalizada para atender às necessidades da sua empresa relacionadas ao sistema SAP. Com a gente você tem:',
      list: ['Consultoria SAP;', 'Implantação;', 'Atualização;', 'Suporte sempre que necessário.'],
    },
    carouselConsulting: {
      title: 'Uma consultoria feita para você',
      list: [
        {
          title: 'Planejamento de Recursos Empresariais',
          text: 'O SAP S/4HANA Cloud é um sistema que já possui a IA embarcada, ajudando a sua empresa a operar de qualquer lugar, em tempo real.',
          icon: '/images/sap/icons-carousel/1.svg',
        },
        {
          title: 'Gestão de Recursos Financeiros (GRC)',
          text: 'Concentre todas as etapas financeiras da sua empresa em um só lugar. Desde o planejamento até GRC.',
          icon: '/images/sap/icons-carousel/2.svg',
        },
        {
          title: 'Gestão de Capital Humano',
          text: 'Soluções SAP para fazer a gestão de talentos, experiência do colaborador e funções relacionadas ao RH.',
          icon: '/images/sap/icons-carousel/3.svg',
        },
        {
          title: 'Gestão de Cadeia Produtiva',
          text: 'Implante o SAP com a gente e administre a sua cadeia de suprimentos, produção e logística.',
          icon: '/images/sap/icons-carousel/4.svg',
        },
        {
          title: 'Vendas e Experiência do Cliente',
          text: 'Conecte dados de e-commerce, vendas e serviços, personalizando o atendimento ao seu cliente.',
          icon: '/images/sap/icons-carousel/5.svg',
        },
        {
          title: 'Rede de Negócios',
          text: 'Conecte pessoas, processos e tecnologias por meio da implantação do sistema SAP ERP.',
          icon: '/images/sap/icons-carousel/6.svg',
        },
      ],
    },
    whatIs: {
      title: 'O que a Inteligência SAP inclui?',
      tooltip:
        '<span class="font-black">É importante lembrar que até 2027</span>, todas as empresas que possuem SAP ECC <span class="font-black">devem fazer a migração para o SAP S/4 HANA.</span> Se você já utiliza a ferramenta e quer ter uma transição segura, nós oferecemos todo o auxílio necessário.',
      list: [
        {
          title:
            '<span class="font-black"> Consultoria e Implantação SAP </span><br><span style="font-weight: 100;"> (ECC e S/4 HANA)</span>',
          items: [
            '• Implantações e migrações de aplicações SAP, atuais ou futuras;',
            '• Diagnóstico completo do ambiente SAP, incluindo customizações (Zs);',
            '• Melhorias nas aplicações já existentes;',
            '• Time especializado.',
          ],
        },
        {
          title: '<span class="font-black">SAP<br>AMS</span>',
          items: [
            '• Suporte às aplicações de negócios;',
            '• Time dedicado ao AMS para atender aos chamados de acordo com a priorização, severidade e mitigar impactos com soluções de contorno e análises de causa-raiz;',
            '• Gestão proativa, baseada em indicadores e acordos de níveis de serviços.',
          ],
        },
        {
          title: '<span class="font-black">SAP<br>CONCUR</span>',
          items: [
            '• Automatização e simplificação de processos de despesas e viagens corporativas;',
            '• Facilidade no preenchimento do relatório de viagem e auxílio na organização do deslocamento desde a reserva até o reembolso.',
          ],
        },
        {
          title: '<span class="font-black">PRICEFX</span>',
          items: [
            '• Solução estratégica para otimização de processos de precificação;',
            '• Otimização de processos de precificação;',
            '• Dados em tempo real e insights para ações;',
            '• Gestão de preços flexível e escalável.',
          ],
        },
        {
          title: '<span class="font-black"> OMNIPOS </span><br><span style="font-weight: 100;">(OMNICHANNEL)</span>',
          items: [
            '• Solução para integração dos canais de venda (e-commerce, PDV e outros) com sistemas ERP e legados (omnicanalidade);',
            '• Gestão de vários canais de vendas de forma separada.',
          ],
        },
        {
          title: '<span class="font-black">ANFE</span>',
          items: [
            '• Gestão e automação na entrada de documentos fiscais eletrônicos (NFe, CTe e NFSe);',
            '• Resgate de documentos direto da SEFAZ;',
            '• Captura, auditoria e classificação de documentos;',
            '• Tratamento de todas as notas fiscais de serviços (PDF e XML).',
          ],
        },
      ],
      link: 'fale com a gente',
    },
    band: {
      title: 'Dê o próximo passo em direção a<br> Inovação e Transformação Digital!',
      button: 'Fale com a nossa Unidade de Inteligência SAP',
    },
    booster: {
      title: 'Impulsione os seus negócios com a implantação do SAP!',
      desc: 'Em parceria com a CoachIT, <span class="font-black">personalizamos a estratégia ideal para atender as necessidades específicas da sua empresa.</span> Utilizando de toda a experiência que possuímos na área de tecnologia, nossos consultores te acompanham desde a implantação até as melhorias contínuas para você alcançar os melhores resultados.',
      link: 'Quero aproveitar os benefícios do SAP!',
    },
  },
}
